import { BasicHeadingControl } from '../../engineClient/components/headings/basicHeadingControl';
import { HpHeadingControlProps } from '../../engineClient/components/headings/headingTypes';
import { resolveSectionText } from '../../tools/sectionTextResolver';

export function ClaimsJourneyHeadingControl(): JSX.Element | null {
  return null;
}

export function ClaimsJourneyInnerHeadingControl({
  answers,
  isLoading,
  sectionHeading,
  sectionSubheading
}: HpHeadingControlProps): JSX.Element | null {
  let heading: string;
  if (isLoading) {
    heading = 'Our list of questions will appear shortly';
  }

  const resolvedHeading = resolveSectionText(sectionHeading, answers);
  if (!resolvedHeading) {
    return null;
  } else {
    heading = resolvedHeading;
  }

  return <BasicHeadingControl heading={heading} subheading={resolveSectionText(sectionSubheading, answers)} />;
}
